import type { InjectionKey, Ref } from 'vue'
import type { Currency } from '../CurrencyRef'

export interface CurrenciesService {
  currencies: Ref<Currency[]>
  allPlatformCurrencies: Ref<Currency[]>
  addCurrency(currency: Currency): Promise<void>
  removeCurrency(code: string): Promise<void>
  fetchCurrencies(forceFetch?: boolean): Promise<void>
  fetchAllPlatformCurrencies(forceFetch?: boolean): Promise<void>
}

export const currenciesKey = Symbol(
  'gs-currencies'
) as InjectionKey<CurrenciesService>
